module.exports = "<app-main></app-main>\r\n"